module.exports = __webpack_public_path__ + "img/logo_dark.9c2e184b.png";